import React from 'react';
import Card from '../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface KPISectionProps {
  filters: {
    dateRange: string;
    region: string;
    businessUnit: string;
    productLine: string;
  };
}
const KPISection: React.FC<KPISectionProps> = ({
  filters
}) => {
  const kpis = [{
    title: 'Revenue YTD',
    value: '₹9,250 Cr',
    change: '+5.2%',
    isPositive: true
  }, {
    title: 'Margin %',
    value: '14.8%',
    change: '+0.7%',
    isPositive: true
  }, {
    title: 'Inventory Days',
    value: '42',
    change: '-3',
    isPositive: true
  }, {
    title: 'Service TAT',
    value: '3.2 days',
    change: '-0.5',
    isPositive: true
  }, {
    title: 'Warranty Cost',
    value: '₹185 Cr',
    change: '+2.1%',
    isPositive: false
  }, {
    title: 'Net Debt/Equity',
    value: '0.32',
    change: '-0.05',
    isPositive: true
  }];
  return <div className="mb-8" data-id="element-4856">
      <div className="flex items-center justify-between mb-6" data-id="element-4857">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-4858">
          Key Performance Indicators
        </h2>
        <div className="text-sm text-gray-500" data-id="element-4859">
          {filters.dateRange} • {filters.region}
          {filters.businessUnit !== 'All Units' && ` • ${filters.businessUnit}`}
          {filters.productLine !== 'All Products' && ` • ${filters.productLine}`}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4" data-id="element-4860">
        {kpis.map((kpi, index) => <Card key={index} className="p-4" data-id="element-4861">
            <div className="flex flex-col h-full" data-id="element-4862">
              <div className="text-sm font-medium text-gray-500" data-id="element-4863">
                {kpi.title}
              </div>
              <div className="mt-2 text-2xl font-semibold text-gray-800" data-id="element-4864">
                {kpi.value}
              </div>
              <div className={`mt-1 text-sm flex items-center ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-4865">
                {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-4866" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-4867" />}
                {kpi.change}
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
};
export default KPISection;